import { render } from "./EventsFilter.vue?vue&type=template&id=2907191e&scoped=true"
import script from "./EventsFilter.vue?vue&type=script&lang=js"
export * from "./EventsFilter.vue?vue&type=script&lang=js"

import "./EventsFilter.vue?vue&type=style&index=0&id=2907191e&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2907191e"]])

export default __exports__